/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

//<custom-head>
import { formattedDate, parseDate, utcFormattedDate } from 'app/utils';
//</custom-head>

export class ClearanceCaseInvoiceDto {
  public id: string = undefined;
  public invoiceNumber: string = undefined;
  public invoiceDate: Date | string;
  public attachedDocumentSubtypeId: number = undefined;
  public isInvoiceNumberRequired: boolean;

  //<custom-body>
  static fromForm(formObject: any): ClearanceCaseInvoiceDto {
    if (!formObject.invoiceNumber && !formObject.invoiceDate)
      return null;

      let date = utcFormattedDate(formObject.invoiceDate, true) + "T00:00Z";

    return new ClearanceCaseInvoiceDto({
      id: formObject.id !== '' ? formObject.id : null,
      invoiceNumber: formObject.invoiceNumber,
      invoiceDate: parseDate(date),
      attachedDocumentSubtypeId: formObject.attachedDocumentSubtypeId,
      isInvoiceNumberRequired: formObject.isInvoiceNumberRequired || false
    } as ClearanceCaseInvoiceDto);
  }

  public constructor(source: ClearanceCaseInvoiceDto) {
    Object.assign(this, source);

    this.invoiceDate = parseDate(source.invoiceDate);
  }

  public get displayDiff(): string {
    return `${this.invoiceNumber} (${this.invoiceDateFormatted})`;
  }

  public get invoiceDateFormatted(): string {
    return formattedDate(parseDate(this.invoiceDate), true);
  }
  //</custom-body>
}
